import React from "react";
import { DataFramework } from "./DataFramework";
import { Link } from "react-router-dom";
const Framework = () => {
  return (
    <div className="blockPage__content">
      {DataFramework.map((item, index) => {
        return (
          <ul key={index} className="blockPage__lists">
            <li className="blockPage__lists--item">
              <Link className="blockPage__lists--link" to={item.path}>
                <img className={item.cName} src={item.icon} alt="icon" />
                <p className="blockPage__lists--title">{item.title}</p>
              </Link>
              <p className="blockPage__lists--text"> {item.description} </p>
            </li>
          </ul>
        );
      })}
    </div>
  );
};

export default Framework;
